export default {
  title: 'Ad-Hoc Models',
  createButton: 'Create Ad-Hoc Model',
  searchLabel: 'Search',
  ok: 'Ok',
  headers: {
    modelName: 'Model Name',
    codename: 'Codename',
    pkl: 'PKL',
    pklSize: 'PKL Size',
    modified: 'Modified',
    status: 'Status',
    actions: 'Actions'
  },
  tooltips: {
    recalculateModelReport: 'Recalculate Model Report',
    editAdHocModel: 'Edit Ad-Hoc Model',
    deploy: 'Deploy',
    deleteAdHocModel: 'Delete Ad-Hoc Model',
    version: 'Version'
  },
  deployDialog: {
    title: 'Deploy Model',
    sourceModelName: 'Source model name',
    targetModelName: 'Target model name',
    targetEnvironment: 'Target environment:',
    confirmLabel: "Write 'deploy' to confirm deployment to the selected environment",
    cancel: 'Cancel',
    deploy: 'Deploy',
    deploying: 'Deploying model... Please wait a few seconds',
    modelSuccessfullyDeployed: 'Model successfully deployed',
    errorModelNameExists: 'Model name already exists in target environment',
    internalError: 'Internal error'
  },
  deleteDialog: {
    title: 'Warning',
    deletingAdHocModel: 'Deleting Ad-Hoc Model:',
    confirmMessage: 'It can be recovered for 7 days by asking an administrator. Are you sure?',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  current: 'current',
  versionDeployed: 'Deployed on {date}',
  versionTooltip: 'Version of {name}',
  versionDialog: {
    title: 'Model Version',
    cancel: 'Cancel',
    save: 'Save',
    linked: '{name} is now v{version}. Access copied to {grants} users and {groups} groups.'
  },
  versionErrors: {
    notLatestVersion: 'Only the latest version of a family can be unlinked',
    alreadyInFamily: 'This model is already a version of another model. Unlink it first',
    isFamilyRoot: 'This model is the first version of its own family, so it cannot be a version of another model',
    familyNotFound: 'The selected model no longer exists',
    modelNotFound: 'This model no longer exists',
    notAdHoc: 'Only Ad-Hoc models can have versions',
    internal: 'The version could not be saved',
    linkOnCreate: '{name} was created, but it could not be linked as a new version: {reason}'
  },
  snackbar: {
    recalculating: 'Recalculating model report for {name}...',
    recalculationStarted: "Model report recalculation started for {name}. You'll be notified when it's ready.",
    recalculationError: 'Error recalculating model report for {name}',
    deleteError: 'Error deleting {name}'
  }
}
